import { Box, Grid, InputLabel, Tooltip, Typography } from "@mui/material";
import { EnhancedDropDownRHF, SinNumberRHF } from "@websential/cosmic";

import InfoIcon from '@mui/icons-material/Info';
import { RHookFormNumericFormatTextField } from "../../../components/TaxSlipDataInput/RHookFormNumericFormatTextField";
import { RHookFormTextField } from "../../../components/TaxSlipDataInput/RHookFormTextField";
import React from "react";

// import { RHookFormTextField } from "@websential/cosmic";

export interface ITaxSlipDataInput {
  id: string;
  label: string;
  boxNumber: string;
  showAdjustedInput?: boolean;
  alert?: boolean;
  alertTitle?: string;
  titlePlacement?: any;
  textfield?: any;
  showBoxNumber?: any;
  yesNoField?: any;
  sinField?: any;
}

export const TaxSlipDataInput: React.FC<ITaxSlipDataInput> = ({
  id,
  label,
  boxNumber,
  alert,
  alertTitle,
  titlePlacement,
  textfield,
  showBoxNumber = true,
  yesNoField,
  sinField
}) => {
  return (
    <Grid container columnSpacing={2} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
      <Grid
        size={{ xs: showBoxNumber ? 6 : 8, sm: showBoxNumber ? 6 : 8, md: showBoxNumber ? 6 : 8, lg: showBoxNumber ? 6 : 8, xl: showBoxNumber ? 6 : 8 }}
        sx={{ textAlign: "left", paddingTop: 2 }}
      >
        <InputLabel sx={{ display: "flex" }}>
          <Typography variant="subtitle2">{label}</Typography>
          {alert === true ? (
            <Tooltip title={alertTitle} placement={titlePlacement}>
              <InfoIcon sx={{ fontSize: "1.1rem", margin: "1.5px" }} />
            </Tooltip>
          ) : undefined}
        </InputLabel>
      </Grid>
      {showBoxNumber && <Grid
        size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
        sx={{ textAlign: "right", paddingTop: 2 }}
      >
        <InputLabel>
          <Typography variant="subtitle2">{boxNumber}</Typography>
        </InputLabel>
      </Grid>}
      <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
        {/* <RHookFormTextField id={`${id}`} testId={`${id}-1`} defaultValue="0.00"/> */}
        {textfield ?
          <RHookFormTextField
            id={`${id}`}
            testId={`${id}-1`}
            defaultValue={'0.00'}
            textAlign={'end'}
          /> :
          yesNoField ?
            <Box sx={{ marginTop: "7px" }}><EnhancedDropDownRHF
              selectName={`${id}`}
              testId={`${id}`}
              items={[{ label: "Yes", value: 1 }, { label: "No", value: 0 }]}
            /></Box>
            : sinField ?
              <SinNumberRHF
                id={`${id}`}
                testId={`${id}`}
              />
              :
              <RHookFormNumericFormatTextField
                id={id}
                testId={`${id}`}
                defaultValue={'0.00'}
                textAlign={'end'}
              />
        }
      </Grid>
    </Grid>
  );
};
